/** 주문상세 정기결제 상태 구분 */
export const SubscriptionStatus = {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
    FINISHED: 'FINISHED',
    NONE: 'NONE',
} as const

export type SubscriptionStatusType = Constant<typeof SubscriptionStatus>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PeriodType = {
    ONCE_PER_ONE_DAY: 'ONCE_PER_ONE_DAY',
    ONCE_PER_ONE_WEEK: 'ONCE_PER_ONE_WEEK',
    ONCE_PER_TWO_WEEK: 'ONCE_PER_TWO_WEEK',
    ONCE_PER_THREE_WEEK: 'ONCE_PER_THREE_WEEK',
    ONCE_PER_FOUR_WEEK: 'ONCE_PER_FOUR_WEEK',
    ONCE_PER_SIX_WEEK: 'ONCE_PER_SIX_WEEK',
    ONCE_PER_ONE_MONTH: 'ONCE_PER_ONE_MONTH',
    ONCE_PER_TWO_MONTH: 'ONCE_PER_TWO_MONTH',
    ONCE_PER_THREE_MONTH: 'ONCE_PER_THREE_MONTH',
    ONCE_PER_SIX_MONTH: 'ONCE_PER_SIX_MONTH',
} as const

export type PeriodTypeValues = Constant<typeof PeriodType>

export const PeriodTypeStringMap: Record<PeriodTypeValues, string> = {
    ONCE_PER_FOUR_WEEK: '4주에 한 번',
    ONCE_PER_ONE_DAY: '1일에 한 번',
    ONCE_PER_ONE_MONTH: '1달에 한 번',
    ONCE_PER_ONE_WEEK: '1주에 한 번',
    ONCE_PER_SIX_WEEK: '6주에 한 번',
    ONCE_PER_THREE_MONTH: '3달에 한 번',
    ONCE_PER_THREE_WEEK: '3주에 한 번',
    ONCE_PER_TWO_MONTH: '2달에 한 번',
    ONCE_PER_TWO_WEEK: '2주에 한 번',
    ONCE_PER_SIX_MONTH: '6달에 한 번',
}
